/** The in-app link a click landed on, or undefined when the click was not on one. A new-tab link leaves the page alone. */
export function getInternalLink(target: EventTarget | null): HTMLAnchorElement | undefined {
    const anchor = target instanceof Element ? target.closest("a[href]") : null;
    return anchor instanceof HTMLAnchorElement && anchor.target !== "_blank" && anchor.origin === window.location.origin ? anchor : undefined;
}

export function isInternalLink(target: EventTarget | null) {
    return getInternalLink(target) !== undefined;
}
